import { render, staticRenderFns } from "./DinnerTime.vue?vue&type=template&id=0691e656&scoped=true"
import script from "./DinnerTime.vue?vue&type=script&lang=js"
export * from "./DinnerTime.vue?vue&type=script&lang=js"
import style0 from "./DinnerTime.vue?vue&type=style&index=0&id=0691e656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0691e656",
  null
  
)

export default component.exports